module.exports = __webpack_public_path__ + "img/3.b369b56d.jpg";